import { TIME } from "@bridgesplit/utils";

import { MarketTimeRestrictionType } from "../types";

export const LOAN_HEALTH_THRESHOLD = {
    warning: 0.3,
    danger: 0.1
};

export const LOOP_HEALTH_DANGER_THRESHOLD = 0.03;

export const LOAN_REFINANCE_GRACE_BEFORE_DEFAULT = TIME.DAY * 2;
export const ASSET_TIME_RESTRICTIONS: Record<string, MarketTimeRestrictionType[]> = {
    // FLP.2
    AbVzeRUss8QJYzv2WDizDJ2RtsD1jkVyRjNdAzX94JhG: [MarketTimeRestrictionType.Metals, MarketTimeRestrictionType.Fx],
    // xStocks
    // Tesla
    XsDoVfqeBukxuZHWhdvWHBhgEHjGNst4MLodqsJHzoB: [MarketTimeRestrictionType.UsEquities],
    // Circle
    XsueG8BtpquVJX9LVLLEGuViXUungE6WmK5YZ3p3bd1: [MarketTimeRestrictionType.UsEquities],
    // NVDA
    Xsc9qvGR1efVDFGLrVsmkzv3qi45LTBjeUKSPmx9qEh: [MarketTimeRestrictionType.UsEquities]
};
